module.exports = __webpack_public_path__ + "img/9791195752935.083105de.jpg";